// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var containerTopRight = "_51-1";